/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ApplicableTaxType = {
    Vat: 'VAT',
    Irpf: 'IRPF',
    Other: 'OTHER'
} as const;
export type ApplicableTaxType = typeof ApplicableTaxType[keyof typeof ApplicableTaxType];


export function instanceOfApplicableTaxType(value: any): boolean {
    for (const key in ApplicableTaxType) {
        if (Object.prototype.hasOwnProperty.call(ApplicableTaxType, key)) {
            // @ts-ignore
            if (ApplicableTaxType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApplicableTaxTypeFromJSON(json: any): ApplicableTaxType {
    return ApplicableTaxTypeFromJSONTyped(json, false);
}

export function ApplicableTaxTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicableTaxType {
    return json as ApplicableTaxType;
}

export function ApplicableTaxTypeToJSON(value?: ApplicableTaxType | null): any {
    return value as any;
}

